import { Injectable } from "@angular/core";
import { HttpService } from "@services/http.service";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Result, WiAccountPagedResult } from "../shared/dto/result.dto";
import { HttpParams } from "@angular/common/http";
import { BaseFilter } from "../shared/dto/base-filter.dto";
import { UserInfo } from "../dto/account-user/account-user.dto";
import { CreateUserInfo } from "../dto/account-user/create-account-user.dto";
import { DeleteUserInfo } from "../dto/account-user/delete-account-user.dto";
import { AccountUpdateRoleRequestDto } from "../dto/account-user/account-update-role-request.dto";
import { HelperDataRequest } from "@services/helper-data.service";

@Injectable({ providedIn: 'root' })
export class AccountUserService {
    constructor(private http: HttpService) {
    }

    private _BASE_URL: string = environment.apiBaseUrl;
    private _TABLE: string = "account-users";
    private _TABLE_INVOICE: string = "account-users-invoice";

    getPaged(filter: BaseFilter): Observable<WiAccountPagedResult<UserInfo>> {
        const {
            pageNumber = 1,
            pageSize = 10,
            searchTerm = null,
        } = filter;

        const dto = HelperDataRequest.convertDataRequest(
            pageSize,
            pageNumber,
            undefined,
            undefined,
            searchTerm ?? ''
        );

        const params = new HttpParams()
            .set('skipCount', String(dto.skipCount ?? 1))
            .set('maxResultCount', String(dto.maxResultCount ?? 10))
            .set('searchText', dto.searchText ?? '')
        return this.http.get(`${this._BASE_URL}/${this._TABLE}`, { params });
    }

    getPagedByApp(filter: BaseFilter): Observable<WiAccountPagedResult<UserInfo>> {
        const {
            pageNumber = 1,
            pageSize = 10,
            searchTerm = null,
        } = filter;

       const dto = HelperDataRequest.convertDataRequest(
            pageSize,
            pageNumber,
            undefined,
            undefined,
            searchTerm ?? ''
        );

        const params = new HttpParams()
            .set('skipCount', String(dto.skipCount ?? 1))
            .set('maxResultCount', String(dto.maxResultCount ?? 10))
            .set('searchText', dto.searchText ?? '')

        return this.http.get(`${this._BASE_URL}/${this._TABLE}/get-by-app`, { params });
    }

    post(body: CreateUserInfo): Observable<void> {
        return this.http.post(`${this._BASE_URL}/${this._TABLE}/add-to-app`, body)
    }

    delete(body: DeleteUserInfo): Observable<void> {
        return this.http.delete(`${this._BASE_URL}/${this._TABLE_INVOICE}/remove-from-app`, body)
    }

    /** Lấy thông tin user hiện tại từ API auth/get-current-user. */
    getCurrentUser(): Observable<UserInfo | Result<UserInfo>> {
        return this.http.get(`${this._BASE_URL}/${this._TABLE_INVOICE}/get-current-user`);
    }

    /** Lấy danh sách role của user đang đăng nhập. */
    getCurrentUserRoles(): Observable<string[] | Result<string[]>> {
        return this.http.get(`${this._BASE_URL}/${this._TABLE_INVOICE}/roles-current`);
    }

    /** Lấy danh sách role của user mục tiêu theo ID. */
    getRolesByUserId(userId: string): Observable<string[] | Result<string[]>> {
        return this.http.get(`${this._BASE_URL}/${this._TABLE_INVOICE}/roles-user/${encodeURIComponent(userId)}`);
    }

    /** Cập nhật danh sách role mong muốn cho user. */
    updateRolesByUserId(request: AccountUpdateRoleRequestDto): Observable<Result<void>> {
        return this.http.put(
            `${this._BASE_URL}/${this._TABLE_INVOICE}/roles-user`,
            request
        );
    }
}
